<template>

    <DataTable :value="listaResultado" selectionMode="single" class="p-datatable-sm p-datatable-gridlines p-datatable-striped mt-3"
                  dataKey="codInscricao" responsiveLayout="scroll" ref="rs" exportFilename="Resultado reservadas">
            <!-- template #header>
              <div class="flex justify-content-start align-items-center h-2rem">
                <h6 class="m-0 font-bold ">{{titulo}}</h6>
              </div>
            </template -->
            <Column field="colocacao" header="Posição" :headerStyle="{ width: '1rem' }"/>
            <Column field="codInscricao" header="Inscrição" :headerStyle="{ width: '1rem' }"/>
            <Column field="usuarioNome" header="Candidato" :headerStyle="{ width: '4rem' }"/>
            <Column field="instituicaoEnsino.descricao" header="Instituição" :headerStyle="{ width: '4rem' }" v-if="processoSeletivo.analiseDocumental"/>
            <Column field="concorreVagasReservadas" header="Concorre vagas reservadas" dataType="boolean" :headerStyle="{ width: '6em' }">
              <template #body="{data}">
                {{ data.concorreVagasReservadas == true ? "Sim" : "Não" }}
              </template>
            </Column>
            <Column field="coefic_red_escolar" header="Coeficiente de rendimento escolar" :headerStyle="{ width: '6rem' }" v-if="processoSeletivo.analiseDocumental"/>
            <Column field="horasCursadas" header="Horas Cursadas" :headerStyle="{ width: '2rem' }" v-if="processoSeletivo.analiseDocumental"/>
            <Column field="pontuacaoHoras" header="Pontuação por Horas Cursadas" :headerStyle="{ width: '2rem' }" v-if="processoSeletivo.analiseDocumental"/>
            <Column field="notaProva" header="Nota da prova" :headerStyle="{ width: '2rem' }" v-if="!processoSeletivo.analiseDocumental"/>
            <Column field="notaProvaDiscursiva" header="Nota Discursiva" :headerStyle="{ width: '2rem' }" v-if="!processoSeletivo.analiseDocumental"/>
            <Column field="notaFinal" header="Nota final" :headerStyle="{ width: '2rem' }"/>
    </DataTable>

</template>
<script>
export default {
    props: {
        listaResultado: [],
        processoSeletivo: null,
        titulo: {
          default: "Resultado"
        }
    },
    data() {
        return {
            showDialog: false,
        }
    }
}
</script>